import './bootstrap';
import './Lib/lib';
import '../css/app.css';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { hydrateRoot } from 'react-dom/client';
import { AppProvider } from '@/Components/Providers/AppProvider';

createInertiaApp({
    title: title => title,
    // @ts-ignore
    resolve: name => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx', { eager: true })),
    setup({ el, App, props }) {
        hydrateRoot(el,
            <AppProvider>
                <App {...props} />
            </AppProvider>
        );
    },
})
